/* SIFT · Filter cutaway — hotspots on the cartridge photo.

   The markup is rendered by Liquid, so every layer's copy is in the HTML whether
   or not this file runs: search engines read all of it, and with JavaScript off
   the list simply stays open. This only adds the interaction. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.slCutInit) return;
    root.dataset.slCutInit = '1';
    root.classList.add('sl-cut-js');

    var fig = root.querySelector('.sl-cut-fig');
    var stage = root.querySelector('.sl-cut-stage');
    var panel = root.querySelector('.sl-cut-panel');
    var pop = root.querySelector('.sl-cut-pop');
    var rows = root.querySelectorAll('.sl-cut-row');
    if (!fig || !stage || !panel || !rows.length) return;

    var count = rows.length;
    var current = -1;

    function q(sel) { return root.querySelector(sel); }
    function at(sel, i) { return root.querySelector(sel + '[data-i="' + i + '"]'); }

    /* the card only exists on the narrow layout; the list does that job above it */
    function cardMode() { return pop && getComputedStyle(pop).display !== 'none'; }

    function fillCard(i) {
      var row = rows[i];
      var pill = row.querySelector('.sl-cut-pill');
      var popPill = q('.sl-cut-poppill');
      q('.sl-cut-popnum').textContent = i + 1;
      q('.sl-cut-poptitle').textContent = row.querySelector('h3').textContent;
      q('.sl-cut-popbody').textContent = row.querySelector('.sl-cut-body p').textContent;
      q('.sl-cut-popcount').textContent = (i + 1) + ' / ' + count;
      if (popPill) {
        popPill.textContent = pill ? pill.textContent : '';
        popPill.style.display = pill ? '' : 'none';
      }
    }

    /* Hinge from whichever edge leaves the dot you just tapped uncovered.
       Measured rather than guessed, because the card's height depends on how much
       copy a layer carries and the dots move whenever the photo is changed. */
    function layout(i) {
      var figR = fig.getBoundingClientRect();
      var dot = at('.sl-cut-dot', i).getBoundingClientRect();
      var cardH = pop.offsetHeight || figR.height * 0.5;
      var gap = 14, pad = 8;
      var roomAbove = dot.top - figR.top;
      var roomBelow = figR.bottom - dot.bottom;

      var anchor = roomBelow >= cardH + gap + pad ? 'bottom'
                 : roomAbove >= cardH + gap + pad ? 'top'
                 : (roomAbove > roomBelow ? 'top' : 'bottom');

      /* A card tall enough for real copy cannot always clear a dot near the middle
         by picking an edge. Slide the diagram the few pixels needed rather than
         covering the dot the customer just pressed. */
      var shift = 0;
      if (anchor === 'bottom') {
        var overBottom = cardH + gap + pad - roomBelow;
        if (overBottom > 0) shift = -overBottom;
      } else {
        var overTop = cardH + gap + pad - roomAbove;
        if (overTop > 0) shift = overTop;
      }
      stage.style.transform = shift ? 'translateY(' + Math.round(shift) + 'px)' : '';
      return anchor;
    }

    function closeCard() {
      if (pop) pop.classList.remove('on');
      fig.classList.remove('popped');
      stage.style.transform = '';
    }

    function select(i) {
      fig.classList.add('touched');

      for (var j = 0; j < count; j++) {
        var on = i === j;
        var band = at('.sl-cut-band', j);
        var dot = at('.sl-cut-dot', j);
        var tag = at('.sl-cut-tag', j);
        if (band) band.classList.toggle('on', on);
        if (dot) dot.classList.toggle('on', on);
        if (tag) tag.classList.toggle('on', on);
        rows[j].classList.toggle('on', on);
        rows[j].querySelector('.sl-cut-rowbtn').setAttribute('aria-expanded', on ? 'true' : 'false');
        var body = rows[j].querySelector('.sl-cut-body');
        body.style.maxHeight = on ? body.scrollHeight + 30 + 'px' : '0px';
      }

      if (!cardMode()) { current = i; return; }
      if (i < 0) { closeCard(); current = i; return; }

      var wasOpen = pop.classList.contains('on');
      var prevAnchor = pop.dataset.anchor;
      fillCard(i);
      var anchor = layout(i);
      var anchorChanges = wasOpen && prevAnchor !== anchor;
      pop.dataset.anchor = anchor;
      fig.classList.add('popped');

      if (!wasOpen || anchorChanges) {
        /* let the new hinge edge apply before flipping up from it */
        pop.classList.remove('on');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { pop.classList.add('on'); });
        });
      } else {
        pop.classList.remove('swap');
        void pop.offsetWidth;
        pop.classList.add('swap');
      }
      current = i;
    }

    fig.addEventListener('click', function (e) {
      if (e.target.closest('.sl-cut-pop')) return;
      var el = e.target.closest('[data-i]');
      if (!el) return;
      var i = +el.dataset.i;
      select(i === current && cardMode() ? -1 : i);
    });

    panel.addEventListener('click', function (e) {
      var row = e.target.closest('.sl-cut-row');
      if (!row) return;
      var i = Array.prototype.indexOf.call(rows, row);
      select(row.classList.contains('on') ? -1 : i);
    });

    if (pop) {
      pop.addEventListener('click', function (e) {
        if (e.target.closest('.sl-cut-popx')) { select(-1); return; }
        var step = e.target.closest('[data-step]');
        if (step) select((current + +step.dataset.step + count) % count);
      });
    }

    /* arrow keys walk the dots, which is how a diagram like this should behave */
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var el = e.target.closest('.sl-cut-dot');
      if (!el) return;
      e.preventDefault();
      var next = (+el.dataset.i + (e.key === 'ArrowDown' ? 1 : -1) + count) % count;
      at('.sl-cut-dot', next).focus();
      select(next);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop && pop.classList.contains('on')) select(-1);
    });

    /* the card and the list are different affordances, so re-sync on a width flip */
    var wasCard = null;
    function sync() {
      var now = cardMode();
      if (now === wasCard) return;
      wasCard = now;
      closeCard();
      select(now ? -1 : 0);
    }
    if (window.ResizeObserver) new ResizeObserver(sync).observe(fig);
    sync();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.sl-cut'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* re-run when the section is re-rendered in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.sl-cut') : null;
    if (root) delete root.dataset.slCutInit;
    boot();
  });
})();
